<template>
  <div class="gx-sw2">
    <top-banner
      :nav-items="navItems"
      :unread="unreadCount"
      @logo="goHome"
      @nav="onNav"
      @bell="goNotification"
      @legacy="goLegacy"
      @logout="logout"
    />

    <div class="gx-layout">
      <!-- 侧栏（新版 wb-select 菜单） -->
      <aside class="gx-sw2__sidebar" :style="{ width: collapsed ? '48px' : '210px' }">
        <button class="gx-sw2__collapse" @click="collapsed = !collapsed">
          <span :style="{ transform: collapsed ? 'rotate(180deg)' : 'none' }">◀</span>
        </button>

        <nav class="gx-sw2__nav">
          <button
            v-for="item in newUiVisibleItems('select', menu)"
            :key="item.id"
            class="gx-sw2__item"
            :class="{ 'gx-sw2__item--on': activeId === item.id }"
            :title="collapsed ? item.label : undefined"
            @click="go(item)"
          >
            <span class="gx-sw2__item-icon">{{ item.icon }}</span>
            <span v-if="!collapsed" class="gx-sw2__item-label">{{ item.label }}</span>
            <span v-if="!collapsed && item.coming" class="gx-sw2__item-coming">开发中</span>
          </button>
        </nav>
      </aside>

      <!-- 内容区 -->
      <main class="gx-main" :class="{'gx-select-main':activeId==='select-main'}">
        <!-- 星人选品 -->
        <new-select-goods-page v-if="activeId === 'select-main'"/>
        <!-- AI定方向 -->
        <ai-set-direction-page v-else-if="activeId==='select-ai-dir'"></ai-set-direction-page>
        <!-- AI找同款 -->
        <ai-find-page v-else-if="activeId==='select-ai-find'"></ai-find-page>
        <!-- 1688选品 -->
        <select-goods1688-page v-else-if="activeId==='select-1688'"></select-goods1688-page>
        <!-- 1688AI工作台 -->
        <select-ai-work-page v-else-if="activeId==='select-1688-work'"></select-ai-work-page>

        <!-- 其他子菜单：开发中 -->
        <div v-else class="gx-sw2__placeholder">
          <div class="gx-sw2__placeholder-icon">🚧</div>
          <div class="gx-sw2__placeholder-title">{{ currentMenu.label }}功能开发中</div>
          <div class="gx-sw2__placeholder-sub">该模块正在按新版 UI 完善中，敬请期待</div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TopBanner from '../../components/newUi/TopBanner.vue'
import NewSelectGoodsPage from '../selectGoods/index.vue'
import SelectAiWorkPage from '../selectAiWork/index.vue'
import AiSetDirectionPage from "../setDirection/index.vue"
import AiFindPage from "../aiFind/index.vue"
import SelectGoods1688Page from "@/pages/selectGoods1688/index.vue";
import newUiPermissionMixin from '../../mixins/newUiPermission'

export default {
  name: 'NewSelectWorkbenchPage',
  mixins: [newUiPermissionMixin],
  components: { TopBanner, NewSelectGoodsPage,AiSetDirectionPage ,AiFindPage,SelectGoods1688Page,SelectAiWorkPage},
  data() {
    return {
      navItems: [
        { id: null, label: '星人工作台' },
        { id: 'agent', label: 'Agent工作台' },
        { id: 'shop', label: '店铺工作台' },
        { id: 'finance', label: '财务工作台' },
        { id: 'ops', label: '运营工作台' },
        { id: 'select', label: '选品工作台', active: true },
        { id: 'cloud', label: '云库工作台' },
        { id: 'goods', label: '商品工作台' },
        { id: 'presales', label: '售前工作台' },
        { id: 'aftersales', label: '售后工作台' },
        { id: 'system', label: '系统工作台' }
      ],
      // 新版 wb-select 菜单（对照 ShopAdminPage.tsx WB_L2_DEFS["wb-select"] 与 ICONS）
      menu: [
        { id: 'select-ai-dir', label: 'AI定方向', icon: '🧭', coming: true },
        { id: 'select-ai-find', label: 'AI找同款', icon: '🔎', coming: true },
        { id: 'select-main', label: '星人选品', icon: '⭐' },
        { id: 'select-1688', label: '1688选品', icon: '🔍', coming: true },
        { id: 'select-1688-work', label: '1688AI工作台', icon: '🤖', coming: true }
      ],
      collapsed: false,
      activeId: 'select-main'
    }
  },
  computed: {
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    },
    currentMenu() {
      return this.menu.find((m) => m.id === this.activeId) || this.menu[2]
    }
  },
  created() {
    const t = this.$route.query.menu
    if (t && this.menu.some((m) => m.id === t)) this.activeId = t
    this.$store.dispatch('notification/initNotificationWS')
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    go(item) {
      this.activeId = item.id
      if (this.$route.path !== '/new_select_workbench' || this.$route.query.menu !== item.id) {
        this.$router.replace({ path: '/new_select_workbench', query: { menu: item.id } }).catch(() => {})
      }
    },
    goLegacy() {
      this.$router.push('/ucenter_legacy')
    },
    onNav(id) {
      if (id === null) {
        this.$router.push('/ucenter')
        return
      }
      const map = {
        agent: '/new_uc_shop_manage',
        shop: '/new_uc_shop_manage',
        finance: '/new_finance_workbench',
        ops: '/new_ops_workbench',
        select: '/new_select_workbench',
        cloud: '/new_cloud_workbench',
        goods: '/new_goods_workbench',
        presales: '/new_presales_workbench',
        aftersales: '/new_aftersales_workbench',
        system: '/new_system_workbench'
      }
      const route = map[id]
      if (!route) {
        this.$message({ message: '该工作台功能开发中，敬请期待', type: 'warning' })
        return
      }
      this.$router.push(route)
    },
    goHome() {
      this.$router.push('/')
    },
    goNotification() {
      this.$router.push('/notification')
    },
    logout() {
      this.OUT_LOGIN()
      this.$message({ message: '已退出登录', type: 'success' })
      location.href = '/'
    }
  }
}
</script>

<style scoped>
.gx-sw2 {
  min-height: 100vh;
  background: #F4F6F8;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-sw2__sidebar {
  flex-shrink: 0;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
  transition: width .25s cubic-bezier(.4, 0, .2, 1);
}
.gx-sw2__sidebar::-webkit-scrollbar {
  display: none;
}
.gx-sw2__collapse {
  position: absolute;
  top: 10px;
  right: -12px;
  z-index: 20;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(212, 169, 70, .3);
  background: #EEF1F6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
}
.gx-sw2__collapse:hover {
  background: #1a2040;
  border-color: #D4A946;
}
.gx-sw2__collapse span {
  font-size: 10px;
  color: #A0AEC0;
  display: inline-block;
  transition: transform .25s;
}

.gx-sw2__nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: none;
}
.gx-sw2__item {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 0 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  transition: all .18s ease;
}
.gx-sw2__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}
.gx-sw2__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 500;
}
.gx-sw2__item-icon {
  font-size: 15px;
  flex-shrink: 0;
}
.gx-sw2__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-sw2__item-coming {
  margin-left: auto;
  padding: 1px 6px;
  border-radius: 4px;
  background: rgba(139, 157, 195, .12);
  border: 1px solid rgba(139, 157, 195, .25);
  font-size: 10px;
  color: #6A6A8A;
  flex-shrink: 0;
}

.gx-sw2__placeholder {
  text-align: center;
  padding: 80px 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, #FFFFFF, rgba(15, 29, 66, .25));
  border: 1px solid #E1E5EE;
}
.gx-sw2__placeholder-icon {
  font-size: 56px;
  margin-bottom: 16px;
}
.gx-sw2__placeholder-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 18px;
  color: #4A4A6A;
  margin-bottom: 8px;
}
.gx-sw2__placeholder-sub {
  font-size: 13px;
  color: #6A6A8A;
}
.gx-select-main{
  background: linear-gradient(rgb(240, 242, 248) 0%, rgb(230, 234, 242) 100%);
}
</style>
